<template>
  <div class="app" v-if="!isLoading">
    <VMedia class="app__header">
      <img v-if="$route.fullPath !== '/about'" src="@/assets/app-header.png" />
      <img v-if="$route.fullPath === '/about'" src="@/assets/app-header-2.png" />
    </VMedia>

    <div class="app__content">
      <transition name="fade" mode="out-in" appear>
        <router-view :key="$route.fullPath" v-if="!isLoading" />
      </transition>
    </div>

    <VMedia class="app__footer" v-if="!['/prizes', '/contest/game', '/contest/game2', '/contest/game3'].includes($route.fullPath)">
      <img src="@/assets/footer.png" v-if="!['/contest/instructions', '/rules'].includes($route.fullPath)" />
      <img src="@/assets/footer-rules.png" v-if="$route.fullPath === '/rules'" />
      <img src="@/assets/footer-instruction.png" v-if="$route.fullPath === '/contest/instructions'" />
    </VMedia>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VMedia from '@/components/VMedia.vue';
import { RESET_LOADING, BEGIN_LOADING, END_LOADING } from '@/store';
import config from '@/config';

export default {
  name: 'App',

  components: {
    VMedia,
  },

  created() {
    const { languageCode } = config;
    
    this.$store.commit(RESET_LOADING);

    this.loadDictionary(languageCode);
  },

  mounted() {
    setTimeout(() => {
      const viacomHeader = document.querySelector('.viacomRoot.ExternalHeader');
      const y = viacomHeader ? viacomHeader.clientHeight : 0;
  
      document.documentElement.scrollTop = y;
  
      console.log(y);
    }, 1000);
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },

  methods: {
    async loadDictionary(languageCode) {
      const FAKE_DELAY = 0;

      this.$store.commit(BEGIN_LOADING);

      this.$i18n.setLocaleMessage(
        languageCode,
        (await this.$bricodes.getDictionary(languageCode)).data,
      );

      this.$i18n.locale = languageCode;

      setTimeout(() => {
        this.$store.commit(END_LOADING);
      }, FAKE_DELAY);
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';
@import '~animate.css/animate.min.css';
@import './styles/main.scss';

@font-face {
  font-family: 'Anton';
  src: url('~@/assets/Anton.woff2') format('woff2'),
    url('~@/assets/Anton.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.viacomRoot {
  z-index: 1000;
}

body {
  background-image: url('~@/assets/bg-toy-left.png'), url('~@/assets/bg-toy-right.png'), url('~@/assets/bg-boy.png'), url('~@/assets/bg-copy.png'), url('~@/assets/body-background.png');
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: 0% 100%, 100% 100%, 92% 30%, top left, center center;
  background-size: 400px auto, 400px auto, 0 0, 350px auto, cover;
  background-attachment: fixed, fixed, fixed, fixed, fixed;

  @media screen and (max-width: 1920px) {
    background-size: 400px auto, 400px auto, 600px auto, 350px auto, cover;
  }

  @media screen and (max-width: 1800px) {
    background-position: 0% 100%, 100% 100%, 94% 30%, top left, center center;
  }

  @media screen and (max-width: 1680px) {
    background-position: 0% 100%, 100% 100%, 98% 30%, top left, center center;
  }

  @media screen and (max-width: 1610px) {
    background-size: 300px auto, 300px auto, 500px auto, 250px auto, cover;
  }
  
  @media screen and (max-width: 1560px) {
    background-size: 200px auto, 200px auto, 400px auto, 250px auto, cover;
    background-position: 0% 100%, 100% 100%, 95% 30%, top left, center center;
  }

  @media screen and (max-width: 1450px) {
    background-size: 0 0, 0 0, 0 0, 0 0, cover;
  }
}

.app {
  overflow: hidden;

  max-width: $width;
  margin: 0 auto;

  font-family: Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  background-image: url('~@/assets/app-background-pattern.png'), url('~@/assets/app-background.png');
  background-repeat: repeat-y, repeat-y;
  background-position: center center, top center;
  background-size: 90% auto, 100% auto;

  &__header {
    margin: 0 auto;
  }

  &__footer {
    margin: 5px auto 0;
  }
}
</style>
